// src/components/AppLayout.jsx
import React from 'react';
// Corrected import path to match component file naming conventions
import NavBar from './navbar';

const AppLayout = ({ children }) => {
  return (
    <div className="app-layout">
      <NavBar />
      <main className="main-content">
        {children}
      </main>
      <footer className="bottom-bar">
        <p>© 2025 Lost &amp; Found. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AppLayout;